<template>

	<!-- NOTE: This component also exists as a php component.
	Be aware of this if you make any changes to the markup/styling. -->

	<li class="c-card-location" :id="card.id">
		<button
			class="c-card-location__trigger"
			@click="collapsed = !collapsed"
			:aria-expanded="!collapsed"
    	>
			<div class="c-card-location__title">
				<h2 class="h6" v-html="card.name"></h2>
				<span class="icon-inline" aria-hidden="true">
					<svg class="icon icon-icon_arrow"><use xlink:href="#icon-icon_arrow_dark"></use></svg>
				</span>
			</div>

			<div class="c-card-location__municipalities" v-html="municipalities"></div>

    	</button>
		<div class="c-card-location__panel" ref="content" :style="style">
        	<div class="c-card-location__content" >

				<div v-if="card.mail" class="c-card-location__item">
					<h3>Postadres</h3>
					<div v-html="card.mail"></div>
				</div>

                <div v-if="card.visit.address || card.visit.phone || card.visit.email || card.visit.website" class="c-card-location__item">
                    <h3>Bezoekadres</h3>
					<div v-html="card.visit.address"></div>
					<a v-if="card.visit.phone" :href="`tel:${card.visit.phone}`" :tabindex="collapsed ? -1 : 0">{{ card.visit.phone }}</a>
					<a v-if="card.visit.email" :href="`mailto:${card.visit.email}`" :tabindex="collapsed ? -1 : 0">{{ card.visit.email }}</a>
					<a v-if="card.visit.website" :href="card.visit.website" :tabindex="collapsed ? -1 : 0">{{ card.visit.website }}</a>
                </div>

				<div v-if="card.info1.label" class="c-card-location__item">
					<h3>{{ card.info1.label }}</h3>
					<div>
						<a v-if="card.info1.phone" :href="`tel:${card.info1.phone}`" :tabindex="collapsed ? -1 : 0">{{ card.info1.phone }}</a>
						<a v-if="card.info1.email" :href="`mailto:${card.info1.email}`" :tabindex="collapsed ? -1 : 0">{{ card.info1.email }}</a>
						<a v-if="card.info1.website" :href="`${card.info1.website}`" :tabindex="collapsed ? -1 : 0">{{ card.info1.website }}</a>
					</div>
				</div>

				<div v-if="card.info2.label" class="c-card-location__item">
					<h3>{{ card.info2.label }}</h3>
					<div>
						<a v-if="card.info2.phone" :href="`tel:${card.info2.phone}`" :tabindex="collapsed ? -1 : 0">{{ card.info2.phone }}</a>
						<a v-if="card.info2.email" :href="`mailto:${card.info2.email}`" :tabindex="collapsed ? -1 : 0">{{ card.info2.email }}</a>
						<a v-if="card.info2.website" :href="`${card.info2.website}`" :tabindex="collapsed ? -1 : 0">{{ card.info2.website }}</a>
					</div>
                </div>
        	</div>
    	</div>
	</li>

</template>

<script>
export default {
	name: 'Office',
	props: {
		card: Object,
		searchTerm: String
	},
	data() {
		return {
			collapsed: true,
		}
	},
	computed: {
		municipalities() {
			const municipalitiesStr = this.card.municipalities.join(', ');
			const result = municipalitiesStr.replace(this.searchTerm, `<span class="search-term">${this.searchTerm}</span>`);
			return result;
		},
		height() {
			if (this.collapsed) {
				return 0;
			}

			return this.$refs.content.scrollHeight;
		},
		style() {
			return {
				'height': `${this.height}px`
			}
		}
	},
};
</script>

<style lang="scss" scoped></style>
